import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { E_FLOW_HEX, L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const COMPRESSOR_CONFIG = {
    type: ERFElement.Compressor,
    icon: 'Compressor_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_flow',
                    type: 'target',
                    name: 'Входной материальный поток',
                    position: Position.Top,
                    style: { top: 14, left: 20, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_flow',
                    type: 'source',
                    name: 'Выходной материальный поток',
                    position: Position.Top,
                    style: { top: 23, left: 36, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_energy_flow',
                    type: 'target',
                    name: 'Входной энергетический поток',
                    position: Position.Right,
                    style: { top: 30, right: 8, background: E_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 65, left: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 45, right: 8, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFCompressorNode.config.js.map